import React from "react";
import { Icon, Stack, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useState from "common/hooks/useState";
import MultiSelect from "common/components/MultiSelect";
import AssetImage from "common/components/AssetImage";
import useFetcher from "common/hooks/useFetcher";
import SidePanel from "common/components/SidePanel";
import SystemInfo from "pages/SystemDash/component/SystemInfo";
import ImageLoader from "common/components/ImageLoader";
import ActionButton from "common/components/ActionButton";
import useConfirm from "common/hooks/useConfirm";
import SystemInstall from "./components/SystemInstall";
import { useDropzone } from "react-dropzone";
import PillButtonGroup from "common/components/PillButtonGroup";
import JSZip from "jszip";
import toast from "react-hot-toast";
import "../../theme/dropzone.css";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
} from "@mui/material";
import ImportWizard from "./components/ImportWizard";
export default function Store({ role }) {
  const { tags, loading, error, refresh } = useState("/api/store/tags");
  const [load, setLoading] = React.useState(false);
  const [install, setInstall] = React.useState(false);
  const [system, setSystem] = React.useState(null);
  const [systems, setSystems] = React.useState([]);
  const [search, setSearch] = React.useState(["ECHELONONE", "flagship"]);
  const [importPanel, setImportPanel] = React.useState(false);
  const [importFile, setImportFile] = React.useState(false);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: async (acceptedFiles) => {
      const formData = new FormData();
      formData.append("file", acceptedFiles[0]);
      setImportFile(acceptedFiles[0]);
      try {
        const zip = new JSZip();
        const zipContent = await zip.loadAsync(acceptedFiles[0]);
        let envs = [];
        try {
          window.zip = zip;
          const promises = Object.keys(zip?.files || {})
            ?.filter((path) => /^actions\/([^/]+)\/config\.json$/i.test(path))
            .map(async (configPath) => {
              return new Promise(async (r) => {
                if (zip.file(configPath)) {
                  try {
                    const jsonData = await zip.file(configPath).async("string");
                    envs = [...envs, ...(JSON.parse(jsonData)?.envs || [])];
                  } catch (jsonError) {
                    console.error(`Invalid JSON in ${configPath}:`, jsonError);
                  }
                } else {
                  console.warn(`No config.json found in ${path}`);
                }
                r();
              });
            });
          await Promise.all(promises);
          // process system import
          const jsonData = await zip.file("config/config.json").async("string");
          const data = JSON.parse(jsonData);
          setImportPanel({ envs, data, type: "system" });
        } catch {
          // process package import
          const jsonData = await zip.file("config.json").async("string");
          const data = JSON.parse(jsonData);
          setImportPanel({ data, type: "package" });
        }
      } catch (error) {
        toast.error("unable to process import");
      }
      //make a call to flask to understand if a package or system and then send back the required form input
      // try {
      //   const response = await fetch("/upload", {
      //     method: "POST",
      //     body: formData,
      //   });
      //   const result = await response.json();
      //   console.log(result);
      // } catch (error) {
      //   console.error("Error:", error);
      // }
    },
    accept: {
      "application/zip": [".zip"],
    },
    multiple: false,
  });
  const navigate = useNavigate();
  const fetcher = useFetcher();
  const deleteHandler = (props, context) => {
    setSystem(null);
    if (!context?.id) return;
    fetcher.delete(
      "deleting resource",
      `/api/store/resource/${context.id}?type=${
        context?.type === "system" ? "system" : "package"
      }`,
      () => {
        refresh();
      },
      () => {}
    );
  };
  const [openDeleteModal, DeleteModal] = useConfirm({
    title: `Unpublish Resource`,
    message: `Are you sure you want to unpublish this resource from Astrohub?`,
    callback: deleteHandler,
  });
  const getSystems = async (tag) => {
    if (!tag) return;
    setLoading(true);
    await fetcher.get(
      "fetching resources",
      `/api/store/tag?tag=${tag}`,
      ({ systems }) => {
        setSystems(systems);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };
  // const filterByTagHandler = async (tag) => {
  //   getSystems(tag);
  //   setSearch(tag);
  // };
  React.useEffect(() => {
    getSystems(["ECHELONONE", "flagship"]);
  }, []);

  return (
    <Box>
      <DeleteModal />
      <SidePanel
        width={800}
        open={!!system}
        closeDrawer={() => setSystem(null)}
        polybg
        props={{
          system: system,
          store: true,
          onInstall: () => {
            setInstall(true);
          },
          onDelete: () => openDeleteModal(true, { ...system }),
          role,
        }}
      >
        {SystemInfo}
      </SidePanel>
      <SidePanel
        width={800}
        open={importPanel}
        closeDrawer={() => {
          setImportFile(null);
          setImportPanel(false);
        }}
        polybg
        props={{
          importFile,
          config: importPanel,
        }}
      >
        {ImportWizard}
      </SidePanel>
      <SidePanel
        width={800}
        open={install}
        closeDrawer={() => setInstall(false)}
        polybg
        props={{
          system: system,
          store: true,
          role,
        }}
      >
        {SystemInstall}
      </SidePanel>
      <div className="astro-hero">
        <div className="astro-hero__bg" />
        <div className="astro-hero__bg2" />
        <div className="astro-hero__header" style={{ "--stacks": 3 }}>
          <h1 style={{ "--index": 0 }}>ASTROHUB</h1>
          <h1 style={{ "--index": 1 }}>ASTROHUB</h1>
          <h1 style={{ "--index": 2 }}>ASTROHUB</h1>
        </div>
        <h2 style={{ fontWeight: "normal" }}>
          <strong>ECHELON</strong>ONE Resource Hub
        </h2>
        <div className="astro-hero__search">
          <MultiSelect
            sx={{ width: "100%" }}
            clearHandler={() => {
              // setSearch(["ECHELONONE"]);
              // getSystems("ECHELONONE");
            }}
            label="Search by Tag"
            loading={loading}
            options={tags || []}
            // multiple={false}
            value={search}
            setValue={(e) => {
              console.log(e);
              if (e?.length > 3) return;
              // getSystems(e);
              setSearch(e);
            }}
          />
          <PillButtonGroup
            options={[
              {
                icon: "search",
                onClick: () => {
                  getSystems(search);
                },
              },
            ]}
          />
        </div>
      </div>
      {systems?.filter((s) => s.type === "system")?.length ? (
        <>
          <Typography pl={2} sx={{ letterSpacing: "1.8px" }} variant="h4">
            SYSTEMS
          </Typography>
          <Grid container spacing={2} padding={2}>
            {systems
              ?.filter((s) => s.type === "system")
              ?.map((item) => (
                <Grid item xs={12} sm={6} md={3} key={item.id}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <ImageLoader
                      apiPath={`/api/assets/store/store/${item.id}/logo.png`}
                      width="100%"
                      height="150px"
                      alt={item.name}
                    />
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography
                        sx={{ fontWeight: "bold" }}
                        gutterBottom
                        variant="body1"
                        component="div"
                      >
                        {item.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.tagline}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "flex-end" }}>
                      <ActionButton
                        icon="info"
                        noload
                        dark
                        handler={async () => {
                          setSystem(item);
                        }}
                      >
                        More Info
                      </ActionButton>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </>
      ) : null}

      {systems?.filter((s) => s.type === "package")?.length ? (
        <>
          <Typography pl={2} sx={{ letterSpacing: "1.8px" }} variant="h4">
            PACKAGES
          </Typography>
          <Grid container spacing={2} padding={2}>
            {systems
              ?.filter((s) => s.type === "package")
              ?.map((item) => (
                <Grid item xs={12} sm={6} md={3} key={item.id}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography
                        sx={{ fontWeight: "bold" }}
                        gutterBottom
                        variant="body1"
                        component="div"
                      >
                        {item.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.tagline}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "flex-end" }}>
                      <ActionButton
                        icon="info"
                        noload
                        dark
                        handler={async () => {
                          setSystem(item);
                        }}
                      >
                        More Info
                      </ActionButton>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </>
      ) : null}
      <Stack p={2} sx={{ width: "100%" }} spacing={2}>
        <Typography sx={{ letterSpacing: "1.8px" }} variant="h4">
          IMPORT
        </Typography>
        <div {...getRootProps()} style={{ width: "100%" }} className="dropzone">
          <input {...getInputProps()} />
          {isDragActive ? (
            <Stack gap={1} direction="row" alignItems="center">
              <Icon color="#eee">upload</Icon>
              <span>Drop the zip file here ...</span>
            </Stack>
          ) : (
            <Stack gap={1} direction="row" alignItems="center">
              <Icon color="#eee">upload</Icon>
              <span>
                Drop a system or package zip file here, or click to select
              </span>
            </Stack>
          )}
        </div>
      </Stack>
      <div style={{ height: "100px" }} />
    </Box>
  );
}
